export default class TimeoutWorker {
    private delaySeconds: number = 60 * 60 * 24; // default to 24 hours
    private callback: () => any = () => {
        /* noop */
    };
    private intervals = false;
    private expectedTime = 0;
    private drift = 0; // milliseconds
    private timeout: NodeJS.Timeout | null = null;

    /**
     * Set the delay to some new value. Will stop and then start the timeout.
     * @param delay The delay in seconds
     */
    public setDelay(delay: number): void {
        this.delaySeconds = delay;

        this.stop();
        this.start();
    }

    /**
     * Set the callback function to some new value. Will not stop or start the timeout.
     * @param callback The callback function to do work
     */
    public setCallback(callback: () => any) {
        this.callback = callback;
    }

    public setIntervals(intervals: boolean): void {
        this.intervals = intervals;
    }

    public start(): void {
        this.expectedTime = Date.now() + this.delaySeconds * 1000;
        const delay = this.delaySeconds * 1000 - this.drift;
        this.timeout = setTimeout(this.expired, Math.max(0, delay));
    }

    public stop(): void {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    /**
     * Important, must be an arrow function to work correctly b/c of the 'this' reference.
     */
    expired = (): void => {
        // Milliseconds of drift
        this.drift = Date.now() - this.expectedTime;
        //console.log(`TimeoutWorker.expired(), Drift[${this.drift}] milliseconds`);

        if (this.callback) {
            this.callback();
        }

        if (this.intervals) {
            this.start();
        }
    };
}
